import React, { Component } from "react";
import logo from "../../logo.png";
import { Menu } from "semantic-ui-react";
import { Link, Icon } from "react-router-dom";
import "./HeaderMenu.css";

class HeaderMenu extends Component {
  state = {};

  render() {
    return (
      <Menu stackable className="HeaderMenu">
        {/* <Menu.Item link>
          <Link to="/dashboard">
            <img className="logo" src={logo} />
          </Link>
        </Menu.Item> */}

        <Menu.Item header name="Crawl Error Tool">
          <Link to="/dashboard">Google Crawl Error Tool</Link>
        </Menu.Item>

        {this.props.isAuthenticated ? (
          <React.Fragment>
            <Menu.Item name="Dashboard">
              <Link to="/dashboard">Dashboard</Link>
            </Menu.Item>

            <Menu.Item name="WebSearch">
              <Link to="/crawl-errors"> Search Websites</Link>
            </Menu.Item>
          </React.Fragment>
        ) : null}

        <Menu.Menu position="right">
          <span className="ttoBrandLink">
            <a href="https://www.321webmarketing.com">Powered by <span className="brand" target="_blank">321 Web Marketing</span></a>
          </span>
          <div className="Logout" />
          <div className="UserInfo">
            <img
              className="UserAvatar"
              src={this.props.user.imageUrl}
              alt={this.props.user.name}
            />
            <span className="Username">{this.props.user.name}</span>
          </div>
        </Menu.Menu>
      </Menu>
    );
  }
}

export default HeaderMenu;



// WEBPACK FOOTER //
// ./src/components/HeaderMenu/HeaderMenu.js